import {makeAutoObservable} from 'mobx';

import {EventEmitter} from '../../core/application/Emitter';

class AppStateManager {
  state: AppStateManager.State = 'active';
  private eventEmitter = new EventEmitter<AppStateManager.State>();

  constructor() {
    makeAutoObservable(this, undefined, {autoBind: true});

    if (
      typeof window !== 'undefined' &&
      typeof window.document !== 'undefined'
    ) {
      this.setState(window.document.hidden ? 'background' : 'active');

      window.document.addEventListener(
        'visibilitychange',
        this.handleStateChange,
      );
    }
  }

  onStateChange(
    listener: EventEmitter.Listener<AppStateManager.State>,
  ): EventEmitter.Unsubscribe {
    return this.eventEmitter.subscribe(listener);
  }

  private handleStateChange() {
    const state = window.document.hidden ? 'background' : 'active';

    if (state === this.state) {
      return;
    }

    this.setState(state);

    this.eventEmitter.emit(state);
  }

  private setState(state: AppStateManager.State) {
    this.state = state;
  }
}

export const appStateManager = new AppStateManager();

export namespace AppStateManager {
  export type State = 'active' | 'background';

  export type Unsubscribe = EventEmitter.Unsubscribe;
}
